import { useFlags } from "launchdarkly-react-client-sdk";

import {
  INBOX_V2_FEATURE,
  TEXTS_NOT_DELIVERED_FEATURE
} from "constants/feature-flags";

/**
 * Whether the Texts not delivered surfaces render (Intercom 215476575290017). `resolveTextsNotDeliveredEnabled`
 * is the flag alone: the patient header, profile, contact form, thread alert and bell row read it.
 * `useTextsNotDeliveredTabEnabled` adds Inbox V2, because the tab and the panel live only there.
 */
export const resolveTextsNotDeliveredEnabled = (flagValue: unknown): boolean =>
  Boolean(flagValue);

export const resolveTextsNotDeliveredTabEnabled = (
  flagValue: unknown,
  inboxV2Value: unknown
): boolean => Boolean(flagValue) && Boolean(inboxV2Value);

export default function useTextsNotDeliveredEnabled(): boolean {
  const flags = useFlags();
  return resolveTextsNotDeliveredEnabled(flags[TEXTS_NOT_DELIVERED_FEATURE]);
}

export function useTextsNotDeliveredTabEnabled(): boolean {
  const flags = useFlags();
  return resolveTextsNotDeliveredTabEnabled(
    flags[TEXTS_NOT_DELIVERED_FEATURE],
    flags[INBOX_V2_FEATURE]
  );
}
